import {AppPages, pageUrl} from "../../app-layout/AppPages";
import {Button} from "@mui/material";
import {Link as RouterLink} from "react-router";
import React, {useMemo} from "react";
import {useAccess} from "../../util/access/UseAccess";

export function DefaultOfficeButton() {
    const access = useAccess();
    const homeUrl = useMemo(() => {
        const userDefaultOfficePath = access.accessibleOffices.getDefaultOfficePath();
        return userDefaultOfficePath ? pageUrl(userDefaultOfficePath, AppPages.home) : null;
    }, [access]);

    return homeUrl ? (
        <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to={homeUrl}
        >
            Back to your Office
        </Button>
    ) : null;
}
